import { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { LI } from '@expo/html-elements';
import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const Item = (props: ItemProps) => {
  const { value, label } = props;

  return (
    <LI style={styles.lineItem}>
      <BodyText sizeMatch={TEXT_SIZE_MATCH}>
        <BodyText sizeMatch={TEXT_SIZE_MATCH} style={styles.nutritionDataText} bold>
          {value}
        </BodyText>

        <BodyText sizeMatch={TEXT_SIZE_MATCH}> </BodyText>

        <BodyText sizeMatch={TEXT_SIZE_MATCH} style={styles.label}>
          {label}
        </BodyText>
      </BodyText>
    </LI>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  lineItem: {
    flexDirection: 'row',
  },
  nutritionDataText: {
    color: theme.colors.TEXT_COLOR,
  },
  label: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const TEXT_SIZE_MATCH: ComponentProps<typeof BodyText>['sizeMatch'] = ['12'];

// ─── Types ───────────────────────────────────────────────────────────────────

type ItemProps = {
  value: string | number;
  label: string;
};
